import "reflect-metadata";
import { getEnvironment } from "@se/designsystem-core";
import { getContainer } from "./siteContainer";
import { SiteEnvironment } from "./environments/siteEnvironment";
import { SiteStartup } from "./siteStartup";

// load the environment settings, then create the inversify container then start the site
getEnvironment<SiteEnvironment>().then(environment => {
	const container = getContainer(environment);
	const startup = container.get(SiteStartup);
	startup.start();
});
